import { ApiHotelItem } from "@/api/hotel";

const useHotelPrice = (data: ApiHotelItem) => {
  const hotelPointValue = `${data.point_val_min || data.min_val || ""}¢ - ${
    data.point_val_median || data.mid_val || ""
  }¢ - ${data.point_val_max || data.max_val || ""}¢`;

  const hotelPointPrice = `${
    [data.points_min / 1000, data.points_median / 1000, data.points_max / 1000]
      .filter(Boolean)
      .map((v) => `${v}K`)
      .join(" - ") || "-"
  }`;

  const isSearchData = data.book_info ? true : false;
  const pointValue = isSearchData
    ? `US$${Math.ceil(data.book_info.cash_rate).toLocaleString()} / night`
    : hotelPointValue;

  const pointPrice = isSearchData
    ? `${Math.ceil(data.book_info.points_rate).toLocaleString()} pts / night`
    : hotelPointPrice;

  return {
    isSearchData,
    pointValue,
    pointPrice,
  };
};

export default useHotelPrice;
